import { Component, OnInit, OnDestroy } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Notification } from 'src/app/interfaces/notification';
import { AwsSharedService } from 'src/app/services/main/shared/aws-shared.service';
import { GlobalService } from 'src/app/services/global.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications = true;
  notificationList: Notification[] = [ ];
  loading = false;
  subscriber: Subscription;
  constructor(
    private globalService: GlobalService,
    private aws: AwsSharedService
  ) {
    this.subscriber = this.globalService.request.subscribe((res) => {
      if (res) {
        switch (res['type']) {
          case 'UPDATENOTIFICATIONS':
            this.getNotifications();
            break;
            default:
            break;
        }
      }
    });
  }

  ngOnInit(): void {
    this.getNotifications();
  }

  ngOnDestroy(): void {
    this.subscriber?.unsubscribe();
  }
  
  async getNotifications(){
    try {
      this.loading = true;
      let result = await firstValueFrom(this.aws.notifications()); 
      this.notificationList = result['data'];
    } catch (error) {
      this.globalService.statusApi(error);
    } finally {
      this.loading = false;
    }
  }

  closeModal() {
    this.globalService.sendRequest({ type: 'CLOSESIDEBARNOTIFICATIONS' });
  }

}
